import * as moment from 'moment-timezone';
import React, { useMemo, useState } from 'react';
import { useCompanyStore } from '../../../stores';

import SlotItem from './SlotItem';
import { formatTime } from '../../../utils/date';

function SlotItemContainer({ data, selectedSlot, onSelectSlot }) {
	const { companySettings: { settings } } = useCompanyStore();

	const today = moment().format('YYYY-MM-DD');

	const noon = moment(formatTime(today, '12:00', 'YYYY-MM-DD HH:mm'));

	const nightStart = moment(formatTime(today, '18:00', 'YYYY-MM-DD HH:mm'));

	const { slotsGrouped, slotIndex } = useMemo(() => {
		const slots = data.slots || [];

		const getSlotShift = slot => {
			const slotStart = moment(formatTime(today, slot.start, 'YYYY-MM-DD HH:mm'));

			if (slotStart.isBefore(noon)) {
				return 'MORNING';
			}

			if (slotStart.isSameOrAfter(nightStart)) {
				return 'NIGHT';
			}

			return 'AFTERNOON';
		};

		const mountSlotsGrouped = slots => {
			return slots.reduce((acc, slot) => {
				const shift = getSlotShift(slot);

				return {
					...acc,
					[shift]: [...acc[shift], slot]
				};
			}, {
				MORNING: [],
				AFTERNOON: [],
				NIGHT: []
			});
		};

		const slotsGrouped = mountSlotsGrouped(slots);

		const slotIndex = selectedSlot ? slots?.findIndex((slot) => slot.id === selectedSlot.id) : null;

		return { slotsGrouped, slotIndex };
	}, [data.slots, selectedSlot, today, noon, nightStart]);

	const [showMoreSlots, setShowMoreSlots] = useState(slotIndex > 2);

	return (
		<SlotItem
			showMoreSlots={showMoreSlots}
			onShowMoreSlots={setShowMoreSlots}
			slotsGrouped={slotsGrouped}
			user={data.user}
			variant={settings?.theme?.name}
			onSelectSlot={onSelectSlot}
			selectedSlot={selectedSlot}
		/>
	);
}

export default SlotItemContainer;
